import React from "react";
import { useDataUnlessForbidden } from "../services/api";
import DocuementSearch from "../classes/DocumentFunctions";
import { useSnackbar } from "notistack";
import IContainer from "./IContainer";
import IProjectHeader from "../models/IProjectHeader";
import IDocument from "../models/IDocument";
import { SearchBox } from "../components/shared/SearchBox";
import { makeStyles } from "@material-ui/core";
import VideosTable from "../components/projectdocuments/VideosTable";

interface IManageProjectVideosContainer extends IContainer {
    projectId: string;
}

const ManageProjectVideosContainer: React.FC<IManageProjectVideosContainer> = ({
    setSubtitle,
    projectId,
    setIsForbidden
}) => {
    const { enqueueSnackbar } = useSnackbar();

    const [searchText, setSearchText] = React.useState("");
    const [showFilters, setShowFilters] = React.useState(false);

    const [filteredDocuments, setFilteredDocuments] = React.useState<
        IDocument[] | null
    >([]);

    const useStyles = makeStyles(theme => ({
        root: {
            minHeight: "500px"
        },
        search: {
            margin: theme.spacing(0, 0, 4, 0)
        },
        buttons: {
            padding: theme.spacing(4, 8, 4),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(2)
            }
        },
        formControl: {
            verticalAlign: "middle"
        },
        label: {
            [theme.breakpoints.down("xs")]: {
                fontSize: "0.9em"
            }
        },
        radio: {
            [theme.breakpoints.down("xs")]: {
                padding: "5px"
            }
        }
    }));

    const [
        filteredSearchDocuments,
        setFilteredSearchDocuments
    ] = React.useState<IDocument[] | null>([]);

    const [
        project,
        isProjectLoading,
        isProjectForbidden
    ] = useDataUnlessForbidden<IProjectHeader>(
        `projects/${projectId}`,
        () =>
            enqueueSnackbar(
                "We couldn't retrieve the project information. Please log out and try again.",
                { variant: "error" }
            )
    );

    const [
        documents,
        isLoadingDocuments,
        isDocumentsForbidden
    ] = useDataUnlessForbidden<IDocument[]>(
        `projects/all/${projectId}/videos`,
        () =>
            enqueueSnackbar(
                "We couldn't retrieve the document information. Please log out and try again.",
                { variant: "error" }
            )
    );

    React.useEffect(() => {
        setIsForbidden(isProjectForbidden || isDocumentsForbidden);
    }, [isProjectForbidden, isDocumentsForbidden, setIsForbidden]);

    React.useEffect(() => {
        if (!isProjectLoading && project !== null && !isLoadingDocuments) {
            setSubtitle(
                `Videos associated with this project '${project!.name}'`
            );
            setFilteredDocuments(documents);
            setFilteredSearchDocuments(documents);
        }
    }, [project, documents, isLoadingDocuments, isProjectLoading, setSubtitle]);

    React.useEffect(
        () => setShowFilters(documents !== null && documents.length > 0),
        [searchText, documents, filteredDocuments]
    );

    React.useEffect(() => {
        const filtered = (filteredDocuments || []).filter(d =>
            DocuementSearch.ContainsSerachText(d, searchText)
        );
        setFilteredSearchDocuments(filtered);
    }, [searchText]);

    const onSearchChange = (text: string) => {
        if (text || []) {
            setSearchText(text.toLowerCase());
        }
    };
    const classes = useStyles();

    return (
        <div className={classes.root}>
            {showFilters ? (
                <div className={classes.search}>
                    <SearchBox
                        onSearchChange={onSearchChange}
                        placeholder="Search video Title, Description, Uploaded By"
                        label="Search Videos"
                        value={searchText}
                    />
                </div>
            ) : (
                <></>
            )}

            <VideosTable
                isLoading={isLoadingDocuments}
                isProcessing={false}
                documents={filteredSearchDocuments}
            />
        </div>
    );
};

export default ManageProjectVideosContainer;
